export default "__VITE_ASSET__Eul5vSp$__"